import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const AccountLinkItem = ({ SvgIcon, text, className }) => (
  <li className={classnames('account-links__link is-flex', className)}>
    <SvgIcon width="22px" height="22px" />
    <span className="account-links__text">{text}</span>
  </li>
);

AccountLinkItem.propTypes = {
  SvgIcon: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default AccountLinkItem;



// WEBPACK FOOTER //
// ./src/common/components/AccountLinks/AccountLinkItem.js